interface AgentIndicatorProps {
  isCoworkerAuthored: boolean;
}

/**
 * Sender-row badge showing message provenance:
 *   - Coworker DM/mention reply → "AI" pill
 *   - Everything else           → null (no badge)
 *
 * Automation-authored rows surface their own framing via
 * `AutomationMessageCard`, so this header pill is reserved for
 * coworker chat. Extracted from Message.tsx to keep that file under
 * the 400-LOC ceiling.
 */
export function AgentIndicator({ isCoworkerAuthored }: AgentIndicatorProps) {
  if (!isCoworkerAuthored) return null;
  return (
    <span
      className="text-[10px] text-muted-foreground shrink-0"
      title="AI Coworker"
    >
      AI
    </span>
  );
}
